import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Indian PAN generator following Single Responsibility Principle
 */
export class PanGenerator extends BaseGenerator {
  constructor() {
    super();
    this.entityTypes = ['P', 'C', 'T', 'F', 'A', 'B', 'G', 'J', 'L', 'H', 'K'];
  }

  generate(options = {}) {
    const { entityType = null, prefix = null } = options;
    
    // Generate first 3 letters (can be custom prefix)
    let firstThree;
    if (prefix && prefix.length >= 3) {
      firstThree = prefix.substring(0, 3).toUpperCase();
    } else {
      firstThree = this.randomLetter() + this.randomLetter() + this.randomLetter();
    }

    // 4th character - entity type
    const fourthChar = entityType || this.entityTypes[this.randomInt(0, this.entityTypes.length - 1)];

    // 5th character - random letter
    const fifthChar = this.randomLetter();

    // 4 digits
    const digits = this.randomDigits(4);

    // Last character - random letter
    const lastChar = this.randomLetter();

    return firstThree + fourthChar + fifthChar + digits + lastChar;
  }

  generateForIndividual() {
    return this.generate({ entityType: 'P' });
  }

  generateForCompany() {
    return this.generate({ entityType: 'C' });
  }

  generateForTrust() {
    return this.generate({ entityType: 'T' });
  }
}